import Player from '@vimeo/player';

export default {
  init($element) {
    // Load YouTube IFrame API
    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  },
  finalize($element) {
    const $video = $element.find('video');
    if ($video.length > 0) {
      const videoId = $video.attr('id');

      const player = videojs(videoId,  { 'loop': true });

      player.on('ready', () => {
        setTimeout(() => {
          player.play();
        }, 350);
      });

      player.on('timeupdate', () => {
        // Set dimensions of the video wrapper.
        const videoWidth = $element.find('video').get()[0].videoWidth;
        const videoHeight = $element.find('video').get()[0].videoHeight;
        const paddingBottom = (videoHeight / videoWidth) * 100;

        $element.find('.media-video-inner').css({ 'padding-bottom': `${paddingBottom}%` });
      })

      $element.find('.player-toggle').on('click', function() {
        if ($(this).hasClass('play')) {
          $(this).removeClass('play');
          player.pause();
        } else {
          $(this).addClass('play');
          player.play();
        }
      });

    }

    // YouTube Player Setup
    const $youtube = $element.find('.media-youtube');
    if ($youtube.length > 0) {
      // Assign unique IDs if not present
      $youtube.each(function(index) {
        if (!$(this).attr('id')) {
          $(this).attr('id', `media-youtube-${index}`);
        }
      });

      function initializeYouTubePlayer() {
        $youtube.each(function() {
          const youtubePlayer = new YT.Player($(this).attr('id'), {
            events: {
              'onReady': (event) => {
                event.target.playVideo();
              },
            },
          });

          $element.find('.youtube-play').on('click', function() {
            const isPlaying = $(this).hasClass('play');
            if (isPlaying) {
              $(this).removeClass('play');
              youtubePlayer.pauseVideo();
            } else {
              $(this).addClass('play');
              youtubePlayer.playVideo();
            }
          });
        });
      }

      if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
        initializeYouTubePlayer();
      } else {
        window.onYouTubeIframeAPIReady = initializeYouTubePlayer;
      }
    }

    // Vimeo Player Setup
    const $vimeo = $element.find('.media-vimeo');
    if ($vimeo.length > 0) {
      const vimeoPlayer = new Player($vimeo);

      vimeoPlayer.ready().then(() => {
        vimeoPlayer.play();
      });

      $element.find('.vimeo-play').on('click', function() {
        const isPlaying = $(this).hasClass('play');
        if (isPlaying) {
          $(this).removeClass('play');
          vimeoPlayer.pause();
        } else {
          $(this).addClass('play');
          vimeoPlayer.play();
        }
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/textAndMedia.js